import React from 'react';

const Chart = (props) => {
  const styleScenario1 = {
    backgroundColor: 'lightgrey',
    width: (props.scenario1 / (props.scenario2 + props.scenario1)) * 100 + '%',
    height: '2rem',
    margin: '3px',
    marginBottom: '10px',
    padding: '6px',
    lineHeight: '2rem',
  };

  const styleScenario2 = {
    backgroundColor: 'darkgrey',
    width: (props.scenario2 / (props.scenario2 + props.scenario1)) * 100 + '%',
    height: '2rem',
    margin: '3px',
    padding: '6px',
    lineHeight: '2rem',
  };

  const panel2Diff = {
    border: '1px solid rgb(66, 60, 60)',
    padding: '5px',
    width: '75%',
    margin: 'auto',
    marginTop: '30px',
  };

  return (
    <div style={panel2Diff}>
      <h1>Difference: {props.formatMoney(Math.abs(props.scenario1 - props.scenario2))}</h1>
      <div style={{ margin: '3px' }}>Investment One</div>
      <div style={styleScenario1}>{props.formatMoney(props.scenario1)}</div>
      <div style={{ margin: '3px' }}>Investment Two</div>
      <div style={styleScenario2}>{props.formatMoney(props.scenario2)}</div>
    </div>
  );
};

export default Chart;
